import { GridColDef } from '@mui/x-data-grid';

import { MappingsWidget } from '../../../../../features/composableAnalytics/DerivedCharts/helper';
import { renderCellFor } from '../../helper';
import { IPostgreMappingsDTO, IPostgreMappingsFields } from '../types';

export function getTableDataForMappings(
  widgetName: MappingsWidget,
  widgetData: IPostgreMappingsDTO
) {
  switch (widgetName) {
    case MappingsWidget.CLIENTS:
    case MappingsWidget.RECRUITER_NAME:
      widgetData.resultSet?.forEach((result, index) => (result.id = index));
      return widgetData.resultSet;
    default:
      return [];
  }
}

export const getColumnsForMappings = (
  widgetName: MappingsWidget,
  widgetData: IPostgreMappingsDTO
): [IPostgreMappingsFields[], GridColDef<any, any, any>[]] => {
  const uniqueSources = Array.from(
    new Set(widgetData?.resultSet?.flatMap((record) => Object.keys(record?.countBySource ?? {})))
  );
  let columns: GridColDef<any, any, any>[];
  switch (widgetName) {
    case MappingsWidget.CLIENTS:
      columns = [
        {
          field: 'company_name',
          headerName: `Client Name`,
          flex: 2,
          renderCell: (params) => renderCellFor('CLIENT', params),
        },
        {
          field: 'count',
          headerName: `Total Count (${widgetData.count})`,
          flex: 1,
        },
      ];
      break;
    case MappingsWidget.RECRUITER_NAME:
      columns = [
        {
          field: 'recruiter_name',
          headerName: `User Name`,
          flex: 2,
          renderCell: (params) => renderCellFor('RECRUITER', params),
        },
        {
          field: 'count',
          headerName: `Total Count (${widgetData.count})`,
          flex: 1,
        },
      ];
      break;
    case MappingsWidget.TABLE_JOB_BOARD:
      columns = [
        { field: 'recruiterName', headerName: 'Recruiter Name', flex: 2 },
        { field: 'count', headerName: `Total (${widgetData.count ?? 0})`, flex: 1 },
        ...uniqueSources.map((source) => ({
          field: source,
          headerName: source,
          width: 110,
        })),
      ];
      break;
    case MappingsWidget.TABLE_JOB_SOURCE:
      columns = [
        { field: 'source', headerName: 'Source', flex: 2 },
        { field: 'count', headerName: `Total Count (${widgetData.count ?? 0})`, flex: 1 },
      ];
      break;
    case MappingsWidget.TABLE_JOB_TITLE:
      columns = [
        {
          field: 'jobTitle',
          headerName: 'Job Title',
          flex: 1.5,
          renderCell: (params) => renderCellFor('JOB', params),
        },
        {
          field: 'jobCode',
          headerName: 'Job Code',
          flex: 1,
          renderCell: (params) => renderCellFor('JOB', params),
        },
        {
          field: 'clientName',
          headerName: 'Client',
          flex: 1,
          renderCell: (params) => renderCellFor('CLIENT', params),
        },
        {
          field: 'count',
          headerName: `Total Count (${widgetData.count ?? 0})`,
          flex: 1,
        },
      ];
      break;
    case MappingsWidget.ACCOUNT_MANAGER:
      columns = [
        {
          field: 'account_manager_name',
          headerName: 'Account Manager Name',
          flex: 2,
          renderCell: (params) => renderCellFor('ACCOUNT_MANAGER', params),
        },
        { field: 'count', headerName: `Total Count (${widgetData.count ?? 0})`, flex: 1 },
      ];
      break;
    case MappingsWidget.JOB_TYPE:
      columns = [
        { field: 'jobType', headerName: 'Job Type', flex: 2 },
        { field: 'count', headerName: `Total Count (${widgetData.count ?? 0})`, flex: 1 },
      ];
      break;
    case MappingsWidget.SOURCE:
      columns = [
        { field: 'source', headerName: 'Source', flex: 2 },
        { field: 'count', headerName: `Total Count (${widgetData.count ?? 0})`, flex: 1 },
      ];
      break;
    case MappingsWidget.DOWNLOAD_SOURCE:
      columns = [
        { field: 'downloadSource', headerName: 'Download Source', flex: 2 },
        { field: 'count', headerName: `Total Count (${widgetData.count ?? 0})`, flex: 1 },
      ];
      break;
    case MappingsWidget.PROFILE_DOWNLOAD_SOURCE:
      columns = [
        { field: 'downloadSource', headerName: 'Download Source', flex: 2 },
        { field: 'count', headerName: `Total Count (${widgetData.count ?? 0})`, flex: 1 },
      ];
      break;
    case MappingsWidget.RECRUITER_TEAM:
      columns = [
        {
          field: 'recruiterName',
          headerName: 'Recruiter Name',
          flex: 1.5,
          renderCell: (params) => renderCellFor('RECRUITER', params),
        },
        {
          field: 'teamName',
          headerName: 'Team Name',
          flex: 1.5,
          renderCell: (params) => renderCellFor('TEAM', params),
        },
        { field: 'count', headerName: `Total Count (${widgetData.count ?? 0})`, flex: 1 },
      ];
      break;
    case MappingsWidget.JOB_TITLE:
      columns = [
        {
          field: 'jobTitle',
          headerName: 'Job Title',
          flex: 1.5,
          renderCell: (params) => renderCellFor('JOB', params),
        },
        {
          field: 'jobCode',
          headerName: 'Job Code',
          flex: 1,
          renderCell: (params) => renderCellFor('JOB', params),
        },
        {
          field: 'clientName',
          headerName: 'Client',
          flex: 1,
          renderCell: (params) => renderCellFor('CLIENT', params),
        },
        { field: 'jobType', headerName: 'Job Type', flex: 1 },
        { field: 'count', headerName: `Total Count (${widgetData.count ?? 0})`, flex: 1 },
      ];
      break;
    case MappingsWidget.RECRUITER_TEAM_JOBTYPE:
      columns = [
        {
          field: 'recruiterName',
          headerName: 'Recruiter Name',
          flex: 1.5,
          renderCell: (params) => renderCellFor('RECRUITER', params),
        },
        {
          field: 'teamName',
          headerName: 'Team Name',
          flex: 1,
          renderCell: (params) => renderCellFor('TEAM', params),
        },
        {
          field: 'jobType',
          headerName: 'Job Type',
          flex: 1,
        },
        { field: 'count', headerName: `Total Count (${widgetData.count ?? 0})`, flex: 1 },
      ];
      break;
    case MappingsWidget.RECRUITER_DOWNLOAD_SOURCE:
      columns = [
        {
          field: 'recruiterName',
          headerName: 'Recruiter Name',
          flex: 1.5,
          renderCell: (params) => renderCellFor('RECRUITER', params),
        },
        {
          field: 'candidateStatus',
          headerName: 'Candidate Status',
          flex: 1,
        },
        {
          field: 'source',
          headerName: 'Download Source',
          flex: 1,
        },
        { field: 'count', headerName: `Total Count (${widgetData.count ?? 0})`, flex: 1 },
      ];
      break;
    case MappingsWidget.RECRUITER_SOURCE:
      columns = [
        {
          field: 'recruiterName',
          headerName: 'Recruiter Name',
          flex: 1.5,
          renderCell: (params) => renderCellFor('RECRUITER', params),
        },
        {
          field: 'candidateStatus',
          headerName: 'Candidate Status',
          flex: 1,
        },
        {
          field: 'source',
          headerName: 'Source',
          flex: 1,
        },
        { field: 'count', headerName: `Total Count (${widgetData.count ?? 0})`, flex: 1 },
      ];
      break;
    case MappingsWidget.TABLE_TIME_TO_SERVICE:
      columns = [
        {
          field: 'time',
          headerName: 'Time',
          flex: 2,
        },
        {
          field: 'numberOfMappings',
          headerName: `No of Mappings (${widgetData.count ?? 0})`,
          minWidth: 100,
          flex: 1,
        },
      ];
      break;
    case MappingsWidget.TABLE_RECRUITERS_MAPPINGS_NO_SUBMISSIONS:
      columns = [
        {
          field: 'recruiterName',
          headerName: 'Recruiter Name',
          flex: 1.5,
          renderCell: (params) => renderCellFor('RECRUITER', params),
        },
        {
          field: 'numberOfMappings',
          headerName: `No of Mappings (${widgetData.count ?? 0})`,
          flex: 1,
        },
        {
          field: 'numberOfSubmissions',
          headerName: 'No of Submissions (0)',
          flex: 1,
        },
      ];
      break;
    default:
      throw new Error('Invalid table widget name');
  }

  widgetData?.resultSet?.forEach((record, index) => {
    record.id = index;
    uniqueSources.forEach((source) => {
      record[source] = record?.countBySource?.[source] ?? 0;
    });
  });

  return [widgetData?.resultSet ?? [], columns];
};
